import { DefaultTitleStrategy, RouterStateSnapshot } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

import { environment } from '@wo-environments';

@Injectable()
export class AppTitleStrategy extends DefaultTitleStrategy {
  private readonly appName = environment.appName;

  public constructor(title: Title) {
    super(title);
  }

  public override buildTitle(snapshot: RouterStateSnapshot): string {
    return super.buildTitle(snapshot) || this.appName;
  }
}
